// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from '@hey-api/client-fetch';
import { client as _heyApiClient } from '../client';
import type {
  ConfigsAdminGetConfData,
  ConfigsAdminGetConfError,
  ConfigsAdminGetConfResponse,
  ConfigsAdminSetConfData,
  ConfigsAdminSetConfError,
  ConfigsGetVersionData,
  ConfigsGetVersionError,
  ConfigsGetVersionResponse,
  ConfigsListErrorsData,
  ConfigsListErrorsError,
  ConfigsListErrorsResponse,
  CreationsAddTagData,
  CreationsAddTagError,
  CreationsAddTagResponse,
  CreationsAdminDeleteData,
  CreationsAdminDeleteError,
  CreationsAdminGetSubTaskIdData,
  CreationsAdminGetSubTaskIdError,
  CreationsAdminGetSubTaskIdResponse,
  CreationsAdminListData,
  CreationsAdminListError,
  CreationsAdminListResponse,
  CreationsAdminUpdateErrCodeData,
  CreationsAdminUpdateErrCodeError,
  CreationsAdminUpdateResourceData,
  CreationsAdminUpdateResourceError,
  CreationsAdminUpdateResourceResponse,
  CreationsBatchGetWatermarkResourceData,
  CreationsBatchGetWatermarkResourceError,
  CreationsBatchGetWatermarkResourceResponse,
  CreationsDeleteData,
  CreationsDeleteError,
  CreationsDeleteTagData,
  CreationsDeleteTagError,
  CreationsDeleteTagResponse,
  CreationsGetData,
  CreationsGetError,
  CreationsGetResponse,
  CreationsGetSharedCreationData,
  CreationsGetSharedCreationError,
  CreationsGetSharedCreationResponse,
  CreationsListData,
  CreationsListError,
  CreationsListResponse,
  CreationsShareData,
  CreationsShareError,
  CreationsShareResponse,
  CreationsUnshareData,
  CreationsUnshareError,
  InferfakeEnqueue2FakeData,
  InferfakeEnqueue2FakeError,
  OfflineAvatarsAdminCopyOfflineAvatarFromLiveData,
  OfflineAvatarsAdminCopyOfflineAvatarFromLiveError,
  OfflineAvatarsAdminCopyOfflineAvatarFromLiveResponse,
  OfflineAvatarsAdminCreateOfflineAvatarData,
  OfflineAvatarsAdminCreateOfflineAvatarError,
  OfflineAvatarsAdminCreateOfflineAvatarResponse,
  OfflineAvatarsAdminDeleteOfflineAvatarData,
  OfflineAvatarsAdminDeleteOfflineAvatarError,
  OfflineAvatarsAdminGetOfflineAvatarData,
  OfflineAvatarsAdminGetOfflineAvatarError,
  OfflineAvatarsAdminGetOfflineAvatarResponse,
  OfflineAvatarsAdminListOfflineAvatarsData,
  OfflineAvatarsAdminListOfflineAvatarsError,
  OfflineAvatarsAdminListOfflineAvatarsResponse,
  OfflineAvatarsAdminSetOfflineAvatarEnabledData,
  OfflineAvatarsAdminSetOfflineAvatarEnabledError,
  OfflineAvatarsAdminSetOfflineAvatarEnabledResponse,
  OfflineAvatarsAdminUpdateOfflineAvatarData,
  OfflineAvatarsAdminUpdateOfflineAvatarError,
  OfflineAvatarsAdminUpdateOfflineAvatarResponse,
  OfflineAvatarsCheckCreateUserOfflineAvatarData,
  OfflineAvatarsCheckCreateUserOfflineAvatarError,
  OfflineAvatarsCheckCreateUserOfflineAvatarResponse,
  OfflineAvatarsCreateUserOfflineAvatarData,
  OfflineAvatarsCreateUserOfflineAvatarError,
  OfflineAvatarsCreateUserOfflineAvatarResponse,
  OfflineAvatarsDeleteUserOfflineAvatarData,
  OfflineAvatarsDeleteUserOfflineAvatarError,
  OfflineAvatarsGetUserOfflineAvatarData,
  OfflineAvatarsGetUserOfflineAvatarError,
  OfflineAvatarsGetUserOfflineAvatarResponse,
  OfflineAvatarsListUserOfflineAvatarsData,
  OfflineAvatarsListUserOfflineAvatarsError,
  OfflineAvatarsListUserOfflineAvatarsResponse,
  OfflineAvatarsUpdateUserOfflineAvatarData,
  OfflineAvatarsUpdateUserOfflineAvatarError,
  OfflineAvatarsUpdateUserOfflineAvatarResponse,
  SchedulersAdminCreateTaskData,
  SchedulersAdminCreateTaskError,
  SchedulersAdminCreateTaskResponse,
  SchedulersAdminEnqueueData,
  SchedulersAdminEnqueueError,
  SchedulersAdminGetQueuesData,
  SchedulersAdminGetQueuesError,
  SchedulersAdminGetQueuesResponse,
  SchedulersAdminGetTaskResultData,
  SchedulersAdminGetTaskResultError,
  SchedulersAdminGetTaskResultResponse,
  SchedulersAdminUpdateTaskStateData,
  SchedulersAdminUpdateTaskStateError,
  StorageCreateFolderData,
  StorageCreateFolderError,
  StorageCreateFolderResponse,
  StorageDeleteData,
  StorageDeleteError,
  StorageDeleteResponse,
  StorageGetTreeData,
  StorageGetTreeError,
  StorageGetTreeResponse,
  StorageListData,
  StorageListError,
  StorageListResponse,
  StorageMoveData,
  StorageMoveError,
  StorageMoveResponse,
  StorageUpdateData,
  StorageUpdateError,
  StorageUpdateResponse,
  TasksAdminGetRealSipTaskData,
  TasksAdminGetRealSipTaskError,
  TasksAdminGetRealSipTaskResponse,
  TasksAdminListData,
  TasksAdminListError,
  TasksAdminListResponse,
  TasksAdminListTaskRegionsData,
  TasksAdminListTaskRegionsError,
  TasksAdminListTaskRegionsResponse,
  TasksAdminUpdateStateData,
  TasksAdminUpdateStateError,
  TasksCancelData,
  TasksCancelError,
  TasksCountData,
  TasksCountError,
  TasksCountResponse,
  TasksCreateAsyncData,
  TasksCreateAsyncError,
  TasksCreateAsyncResponse,
  TasksCreateData,
  TasksCreateError,
  TasksCreateResponse,
  TasksDeleteData,
  TasksDeleteError,
  TasksDetailStatisticsData,
  TasksDetailStatisticsError,
  TasksDetailStatisticsResponse,
  TasksGetCreationsData,
  TasksGetCreationsError,
  TasksGetCreationsResponse,
  TasksGetData,
  TasksGetError,
  TasksGetResponse,
  TasksGetStateData,
  TasksGetStateError,
  TasksGetStateResponse,
  TasksListData,
  TasksListError,
  TasksListResponse,
  TasksUpdateStateByViduData,
  TasksUpdateStateByViduError,
  TasksUsageStatisticsData,
  TasksUsageStatisticsError,
  TasksUsageStatisticsResponse,
  WorkersAdminT5Data,
  WorkersAdminT5Error,
  WorkersAdminT5Response,
  WorkersAdminUpscaleVideoData,
  WorkersAdminUpscaleVideoError,
  WorkersAdminUpscaleVideoResponse,
  WorkersAdminUvitv13bRealData,
  WorkersAdminUvitv13bRealError,
  WorkersAdminUvitv13bRealResponse,
  WorkersAdminVaev1Data,
  WorkersAdminVaev1Error,
  WorkersAdminVaev1Response,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * get a configuration item
 */
export const configsAdminGetConf = <ThrowOnError extends boolean = false>(
  options: Options<ConfigsAdminGetConfData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ConfigsAdminGetConfResponse, ConfigsAdminGetConfError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/conf/{name}',
    ...options,
  });
};

/**
 * set/change a configuration item
 */
export const configsAdminSetConf = <ThrowOnError extends boolean = false>(
  options: Options<ConfigsAdminSetConfData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, ConfigsAdminSetConfError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/conf/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const creationsAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<CreationsAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CreationsAdminListResponse, CreationsAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/creations',
    ...options,
  });
};

export const creationsAdminDelete = <ThrowOnError extends boolean = false>(
  options: Options<CreationsAdminDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, CreationsAdminDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/creations/{id}',
    ...options,
  });
};

export const creationsAdminUpdateErrCode = <ThrowOnError extends boolean = false>(
  options: Options<CreationsAdminUpdateErrCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, CreationsAdminUpdateErrCodeError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/creations/{id}/err_code',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 更新创作资源信息（uri/cover/duration/size）
 */
export const creationsAdminUpdateResource = <ThrowOnError extends boolean = false>(
  options: Options<CreationsAdminUpdateResourceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    CreationsAdminUpdateResourceResponse,
    CreationsAdminUpdateResourceError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/creations/{id}/resource',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 临时接口，sub_task概念 废弃后可以删除
 */
export const creationsAdminGetSubTaskId = <ThrowOnError extends boolean = false>(
  options: Options<CreationsAdminGetSubTaskIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    CreationsAdminGetSubTaskIdResponse,
    CreationsAdminGetSubTaskIdError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/creations/{id}/sub_task_id',
    ...options,
  });
};

export const offlineAvatarsAdminListOfflineAvatars = <ThrowOnError extends boolean = false>(
  options?: Options<OfflineAvatarsAdminListOfflineAvatarsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    OfflineAvatarsAdminListOfflineAvatarsResponse,
    OfflineAvatarsAdminListOfflineAvatarsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/offline-avatars',
    ...options,
  });
};

export const offlineAvatarsAdminCreateOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsAdminCreateOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    OfflineAvatarsAdminCreateOfflineAvatarResponse,
    OfflineAvatarsAdminCreateOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/offline-avatars',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const offlineAvatarsAdminDeleteOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsAdminDeleteOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, OfflineAvatarsAdminDeleteOfflineAvatarError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/offline-avatars/{id}',
    ...options,
  });
};

export const offlineAvatarsAdminGetOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsAdminGetOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    OfflineAvatarsAdminGetOfflineAvatarResponse,
    OfflineAvatarsAdminGetOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/offline-avatars/{id}',
    ...options,
  });
};

export const offlineAvatarsAdminUpdateOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsAdminUpdateOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    OfflineAvatarsAdminUpdateOfflineAvatarResponse,
    OfflineAvatarsAdminUpdateOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/offline-avatars/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const offlineAvatarsAdminSetOfflineAvatarEnabled = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsAdminSetOfflineAvatarEnabledData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    OfflineAvatarsAdminSetOfflineAvatarEnabledResponse,
    OfflineAvatarsAdminSetOfflineAvatarEnabledError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/offline-avatars/{id}/enabled',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const offlineAvatarsAdminCopyOfflineAvatarFromLive = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsAdminCopyOfflineAvatarFromLiveData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    OfflineAvatarsAdminCopyOfflineAvatarFromLiveResponse,
    OfflineAvatarsAdminCopyOfflineAvatarFromLiveError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/offline-avatars:copyFromLive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tasksAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<TasksAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TasksAdminListResponse, TasksAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/tasks',
    ...options,
  });
};

export const tasksAdminGetRealSipTask = <ThrowOnError extends boolean = false>(
  options?: Options<TasksAdminGetRealSipTaskData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    TasksAdminGetRealSipTaskResponse,
    TasksAdminGetRealSipTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/tasks/real-sip-tasks',
    ...options,
  });
};

export const tasksAdminListTaskRegions = <ThrowOnError extends boolean = false>(
  options?: Options<TasksAdminListTaskRegionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    TasksAdminListTaskRegionsResponse,
    TasksAdminListTaskRegionsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/tasks/regions',
    ...options,
  });
};

export const tasksAdminUpdateState = <ThrowOnError extends boolean = false>(
  options: Options<TasksAdminUpdateStateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, TasksAdminUpdateStateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/admin/v1/tasks/{id}/state',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const schedulersAdminGetQueues = <ThrowOnError extends boolean = false>(
  options?: Options<SchedulersAdminGetQueuesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SchedulersAdminGetQueuesResponse,
    SchedulersAdminGetQueuesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/sched/admin/v1/queues',
    ...options,
  });
};

export const schedulersAdminEnqueue = <ThrowOnError extends boolean = false>(
  options: Options<SchedulersAdminEnqueueData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, SchedulersAdminEnqueueError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/sched/admin/v1/queues/enqueue',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const schedulersAdminUpdateTaskState = <ThrowOnError extends boolean = false>(
  options: Options<SchedulersAdminUpdateTaskStateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, SchedulersAdminUpdateTaskStateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/sched/admin/v1/tasks/{id}/state',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * [HTTP] T5 model: generate text embeddings
 */
export const workersAdminT5 = <ThrowOnError extends boolean = false>(
  options: Options<WorkersAdminT5Data, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<WorkersAdminT5Response, WorkersAdminT5Error, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/sched/v1/models/t5',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * temporal activity: upscale video
 */
export const workersAdminUpscaleVideo = <ThrowOnError extends boolean = false>(
  options: Options<WorkersAdminUpscaleVideoData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    WorkersAdminUpscaleVideoResponse,
    WorkersAdminUpscaleVideoError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/sched/v1/models/upscale-video',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * temporal activity: vidu models, one per style, nameing convention: uvit_{rev}_{xB}_{style}
 */
export const workersAdminUvitv13bReal = <ThrowOnError extends boolean = false>(
  options: Options<WorkersAdminUvitv13bRealData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    WorkersAdminUvitv13bRealResponse,
    WorkersAdminUvitv13bRealError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/sched/v1/models/uvit_v1_3b_real',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * temporal activity: vae, reconstruct video from latent space variables, nameing convention: vae_{rev}
 */
export const workersAdminVaev1 = <ThrowOnError extends boolean = false>(
  options: Options<WorkersAdminVaev1Data, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<WorkersAdminVaev1Response, WorkersAdminVaev1Error, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/sched/v1/models/vae_v1',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const schedulersAdminCreateTask = <ThrowOnError extends boolean = false>(
  options: Options<SchedulersAdminCreateTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SchedulersAdminCreateTaskResponse,
    SchedulersAdminCreateTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/sched/v1/tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const schedulersAdminGetTaskResult = <ThrowOnError extends boolean = false>(
  options: Options<SchedulersAdminGetTaskResultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SchedulersAdminGetTaskResultResponse,
    SchedulersAdminGetTaskResultError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/sched/v1/tasks/{id}',
    ...options,
  });
};

export const creationsList = <ThrowOnError extends boolean = false>(
  options?: Options<CreationsListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CreationsListResponse, CreationsListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/creations',
    ...options,
  });
};

export const creationsBatchGetWatermarkResource = <ThrowOnError extends boolean = false>(
  options: Options<CreationsBatchGetWatermarkResourceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreationsBatchGetWatermarkResourceResponse,
    CreationsBatchGetWatermarkResourceError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/creations/batch/watermark',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const creationsDelete = <ThrowOnError extends boolean = false>(
  options: Options<CreationsDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, CreationsDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/creations/{id}',
    ...options,
  });
};

export const creationsGet = <ThrowOnError extends boolean = false>(
  options: Options<CreationsGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<CreationsGetResponse, CreationsGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/creations/{id}',
    ...options,
  });
};

export const creationsUnshare = <ThrowOnError extends boolean = false>(
  options: Options<CreationsUnshareData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, CreationsUnshareError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/creations/{id}/share',
    ...options,
  });
};

export const creationsGetSharedCreation = <ThrowOnError extends boolean = false>(
  options: Options<CreationsGetSharedCreationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    CreationsGetSharedCreationResponse,
    CreationsGetSharedCreationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/creations/{id}/share',
    ...options,
  });
};

export const creationsShare = <ThrowOnError extends boolean = false>(
  options: Options<CreationsShareData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<CreationsShareResponse, CreationsShareError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/creations/{id}/share',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const creationsDeleteTag = <ThrowOnError extends boolean = false>(
  options: Options<CreationsDeleteTagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<CreationsDeleteTagResponse, CreationsDeleteTagError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/creations/{id}/tag',
    ...options,
  });
};

export const creationsAddTag = <ThrowOnError extends boolean = false>(
  options: Options<CreationsAddTagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<CreationsAddTagResponse, CreationsAddTagError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/creations/{id}/tag',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * List Errors info
 */
export const configsListErrors = <ThrowOnError extends boolean = false>(
  options?: Options<ConfigsListErrorsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ConfigsListErrorsResponse, ConfigsListErrorsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/errors',
    ...options,
  });
};

export const offlineAvatarsListUserOfflineAvatars = <ThrowOnError extends boolean = false>(
  options?: Options<OfflineAvatarsListUserOfflineAvatarsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    OfflineAvatarsListUserOfflineAvatarsResponse,
    OfflineAvatarsListUserOfflineAvatarsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/offline-avatars',
    ...options,
  });
};

export const offlineAvatarsCreateUserOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsCreateUserOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    OfflineAvatarsCreateUserOfflineAvatarResponse,
    OfflineAvatarsCreateUserOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/offline-avatars',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const offlineAvatarsCheckCreateUserOfflineAvatar = <ThrowOnError extends boolean = false>(
  options?: Options<OfflineAvatarsCheckCreateUserOfflineAvatarData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    OfflineAvatarsCheckCreateUserOfflineAvatarResponse,
    OfflineAvatarsCheckCreateUserOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/offline-avatars/create/check',
    ...options,
  });
};

export const offlineAvatarsDeleteUserOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsDeleteUserOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, OfflineAvatarsDeleteUserOfflineAvatarError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/offline-avatars/{id}',
    ...options,
  });
};

export const offlineAvatarsGetUserOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsGetUserOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    OfflineAvatarsGetUserOfflineAvatarResponse,
    OfflineAvatarsGetUserOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/offline-avatars/{id}',
    ...options,
  });
};

export const offlineAvatarsUpdateUserOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsUpdateUserOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    OfflineAvatarsUpdateUserOfflineAvatarResponse,
    OfflineAvatarsUpdateUserOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/offline-avatars/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const storageDelete = <ThrowOnError extends boolean = false>(
  options: Options<StorageDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<StorageDeleteResponse, StorageDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/storage/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const storageCreateFolder = <ThrowOnError extends boolean = false>(
  options: Options<StorageCreateFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<StorageCreateFolderResponse, StorageCreateFolderError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/storage/folder',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const storageList = <ThrowOnError extends boolean = false>(options?: Options<StorageListData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<StorageListResponse, StorageListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/storage/list',
    ...options,
  });
};

export const storageMove = <ThrowOnError extends boolean = false>(options: Options<StorageMoveData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<StorageMoveResponse, StorageMoveError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/storage/move',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const storageGetTree = <ThrowOnError extends boolean = false>(
  options?: Options<StorageGetTreeData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<StorageGetTreeResponse, StorageGetTreeError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/storage/tree',
    ...options,
  });
};

export const storageUpdate = <ThrowOnError extends boolean = false>(
  options: Options<StorageUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<StorageUpdateResponse, StorageUpdateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/storage/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const inferfakeEnqueue2Fake = <ThrowOnError extends boolean = false>(
  options: Options<InferfakeEnqueue2FakeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, InferfakeEnqueue2FakeError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/task/Enqueue2fake',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tasksList = <ThrowOnError extends boolean = false>(options?: Options<TasksListData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<TasksListResponse, TasksListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks',
    ...options,
  });
};

export const tasksCreate = <ThrowOnError extends boolean = false>(options: Options<TasksCreateData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<TasksCreateResponse, TasksCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tasksCreateAsync = <ThrowOnError extends boolean = false>(
  options: Options<TasksCreateAsyncData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<TasksCreateAsyncResponse, TasksCreateAsyncError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks/async',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tasksCount = <ThrowOnError extends boolean = false>(options?: Options<TasksCountData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<TasksCountResponse, TasksCountError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks/count',
    ...options,
  });
};

/**
 * 第三方 vidu maas 回调更新任务状态
 */
export const tasksUpdateStateByVidu = <ThrowOnError extends boolean = false>(
  options: Options<TasksUpdateStateByViduData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, TasksUpdateStateByViduError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks/state/vidu',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tasksDetailStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<TasksDetailStatisticsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    TasksDetailStatisticsResponse,
    TasksDetailStatisticsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks/statistics',
    ...options,
  });
};

export const tasksUsageStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<TasksUsageStatisticsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TasksUsageStatisticsResponse, TasksUsageStatisticsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks/usage',
    ...options,
  });
};

export const tasksDelete = <ThrowOnError extends boolean = false>(options: Options<TasksDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<unknown, TasksDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks/{id}',
    ...options,
  });
};

export const tasksGet = <ThrowOnError extends boolean = false>(options: Options<TasksGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<TasksGetResponse, TasksGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks/{id}',
    ...options,
  });
};

export const tasksCancel = <ThrowOnError extends boolean = false>(options: Options<TasksCancelData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<unknown, TasksCancelError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks/{id}/cancel',
    ...options,
  });
};

export const tasksGetCreations = <ThrowOnError extends boolean = false>(
  options: Options<TasksGetCreationsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<TasksGetCreationsResponse, TasksGetCreationsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks/{id}/creations',
    ...options,
  });
};

export const tasksGetState = <ThrowOnError extends boolean = false>(
  options: Options<TasksGetStateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<TasksGetStateResponse, TasksGetStateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/tasks/{id}/state',
    ...options,
  });
};

export const configsGetVersion = <ThrowOnError extends boolean = false>(
  options?: Options<ConfigsGetVersionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ConfigsGetVersionResponse, ConfigsGetVersionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/infer/v1/version',
    ...options,
  });
};
